import {createEntityAdapter, createSlice, EntityId} from '@reduxjs/toolkit';
import {mapValues} from 'lodash';
import {TestimonialEntity} from '~/types/models/testimonial';
import {RootState} from '~/redux/root-reducer';
import {addTestimonial, deleteTestimonial, fetchTestimonials, updateTestimonial} from '~/redux/testimonials/thunk';
import {
  ReducerState,
  addIdsToSources,
  createSelectAllBySource,
  deleteSuccess,
  fetchSuccess,
  upsertMany,
  upsertManyMutably,
  DEFAULT_SOURCE_REDUCER_STATE,
  upsertOneMutably,
} from 'redux-thunk-kit';
import {SOURCES_TESTIMONIAL} from '~/redux/testimonials/entity-config';
import {getObjNthItem} from '~/utils/helpers';

interface InitialState extends ReducerState {}

const sources = mapValues(SOURCES_TESTIMONIAL, () => DEFAULT_SOURCE_REDUCER_STATE);

const testimonialsAdapter = createEntityAdapter<TestimonialEntity>();

const initialState = testimonialsAdapter.getInitialState<InitialState>({sources});

const testimonials = createSlice({
  name: 'testimonials',
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder.addCase(fetchTestimonials.fulfilled, (state, {payload}) => {
      upsertManyMutably(testimonialsAdapter, state, payload.normalized.entities.testimonials);
      fetchSuccess(state, payload);
    });
    builder.addCase(addTestimonial.fulfilled, (state, {payload}) => {
      upsertMany(testimonialsAdapter, state, payload.normalized.entities.testimonials);
      addIdsToSources(state, payload.normalized.result, [SOURCES_TESTIMONIAL.TESTIMONIALS_PAGE]);
    });
    builder.addCase(updateTestimonial.fulfilled, (state, {payload}) => {
      upsertOneMutably(testimonialsAdapter, state, payload.normalized.entities.testimonials);
    });
    builder.addCase(deleteTestimonial.fulfilled, (state, {payload, meta}) => {
      const {arg} = meta;
      testimonialsAdapter.removeOne(state, arg?.id as EntityId);
      deleteSuccess(state, arg?.id);
    });
  },
});

// export const {} = testimonials.actions;

export default testimonials.reducer;

export const {
  selectById: selectTestimonialById,
  selectIds: selectTestimonialsIds,
  selectEntities: selectTestimonialsEntities,
  selectAll: selectAllTestimonials,
  selectTotal: selectTotalTestimonials,
} = testimonialsAdapter.getSelectors((state: RootState) => state.testimonials);

export const [getTestimonials] = createSelectAllBySource('testimonials', selectTestimonialsEntities, [
  SOURCES_TESTIMONIAL.TESTIMONIALS_PAGE,
]);
